/** Organization datagrid key base — full key is `${DEPARTMENTS_DATAGRID_KEY}_${organizationId}` */
export const DEPARTMENTS_DATAGRID_KEY = "departments_grid";

export const DEPARTMENT_DEFAULT_COLUMNS = [
  {
    field: "department_name",
    label: "Department Name",
    visible: true,
    width: 200,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "department_short_name",
    label: "Short Name",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "department_mail_id",
    label: "Email",
    visible: true,
    width: 220,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "department_employees_count",
    label: "Employees Count",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "description",
    label: "Description",
    visible: true,
    width: 250,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

export const DEPARTMENT_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: DEPARTMENT_DEFAULT_COLUMNS.map((col) => col.field),
  columnLabels: Object.fromEntries(
    DEPARTMENT_DEFAULT_COLUMNS.map((col) => [col.field, col.label])
  ),
  columnWidths: Object.fromEntries(
    DEPARTMENT_DEFAULT_COLUMNS.map((col) => [col.field, col.width])
  ),
};

export const DEPARTMENT_PERSONALIZE_COLUMN_KEYS =
  DEPARTMENT_DEFAULT_COLUMNS.map((col) => col.field);

export function normalizeDepartmentColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  if (raw === "id") return "organization_department_id";
  return raw;
}

export function mapSavedDepartmentColumns(savedColumns = []) {
  const labelByField = DEPARTMENT_PERSONALIZE_CONFIG.columnLabels || {};

  return savedColumns
    .map((col) => {
      const field = normalizeDepartmentColumnField(col.field || col.key);
      if (!field || field === "organization_id") return null;

      const defaultCol = DEPARTMENT_DEFAULT_COLUMNS.find(
        (c) => c.field === field
      );

      return {
        ...(defaultCol || {}),
        ...col,
        field,
        key: field,
        label: col.label || labelByField[field] || field,
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}
